import { Device, until } from '@helpers/media';
import KeyInformationCard from '@stories/Components/Cards/KeyInformationCard/KeyInformationCard';
import ImageGallery from '@stories/Components/Carousels/ImageGallery/ImageGallery';
import Iframe from '@stories/Components/Content/Iframe/Iframe';
import InPageNavigation from '@stories/Components/Global/InPageNavigation/InPageNavigation';
import React from 'react';
import { useMedia } from 'react-use';
import Downloads from '../Downloads/Downloads';
import FeaturedArticle from '../FeaturedArticle/FeaturedArticle';
import Profiles from '../Global/Profiles/Profiles';
import GoogleMapWidget from '../GoogleMapWidget/GoogleMapWidget';
import ImageText5050 from '../ImageText5050/ImageText5050';
import RelatedCards from '../RelatedCards/RelatedCards';
import RichText from '../RichText/RichText';
import { ColumnedLayoutStyles as S } from './ColumnedLayout.styles';
import USPCarousel from '../USPCarousel/USPCarousel';
const ColumnedLayout = ({ articleBlockList, keyInformationBlock, sideBlockList, }) => {
    const mobileOnly = useMedia(until(Device.Tablet), false);
    return (React.createElement(S.Container, { flush: "both" },
        React.createElement(S.Inner, null,
            React.createElement(S.ArticleContent, null, articleBlockList && articleBlockList.map((block) => renderArticleBlock(block))),
            React.createElement(S.SideContent, null,
                keyInformationBlock && renderSideBlock(keyInformationBlock),
                !mobileOnly && sideBlockList && sideBlockList.map((block) => renderSideBlock(block))),
            mobileOnly && (React.createElement(S.SideContent, { "data-mobile-only": true }, mobileOnly && sideBlockList && sideBlockList.map((block) => renderSideBlock(block)))))));
    function renderArticleBlock(block) {
        switch (block.name) {
            case 'inPageNavigation':
                return React.createElement(InPageNavigation, { ...block.data });
            case 'profiles':
                return React.createElement(Profiles, { ...block.data });
            case 'richText':
                return React.createElement(RichText, { ...block.data });
            case 'relatedCards':
                return React.createElement(RelatedCards, { ...block.data });
            case 'imageGallery':
                return React.createElement(ImageGallery, { ...block.data });
            case 'googleMapWidget':
                return React.createElement(GoogleMapWidget, { ...block.data });
            case 'imageText5050':
                return React.createElement(ImageText5050, { ...block.data });
            case 'downloads':
                return React.createElement(Downloads, { ...block.data });
            case 'iframe':
                return React.createElement(Iframe, { ...block.data });
            case 'uspCarousel':
                return React.createElement(USPCarousel, { ...block.data });
            default:
                return null;
        }
    }
    function renderSideBlock(block) {
        switch (block.name) {
            case 'featuredArticle':
                return React.createElement(FeaturedArticle, { ...block.data });
            case 'keyInformation':
                return React.createElement(KeyInformationCard, { ...block.data });
            case 'richText':
                return React.createElement(RichText, { ...block.data });
            case 'imageGallery':
                return React.createElement(ImageGallery, { ...block.data });
            default:
                return null;
        }
    }
};
export default ColumnedLayout;
